import $x from '@/utils/$x';

/**
 * 公众号菜单栏-删除
 * @param {*} params
 * @returns
 */
export async function deleteOfficialAccountMenuBar(params,appId) {
  return $x.post(
    '/officialAcocounts/pushManager/deleteOfficialAccountMenuBar?appId='+appId,
    params,
  );
}

/**
 * 公众号菜单栏-创建
 * @param {*} params
 * @returns
 */
export async function createOfficialAccountMenuBar(params,appId) {
  return $x.post(
    '/officialAcocounts/pushManager/createOfficialAccountMenuBar?appId='+appId,
    params,
  );
}

/**
 * 查询
 * @param {*} params
 * @returns
 */
export async function officialAccountMenuBarLast(params,appId) {
  return $x.post(
    '/officialAcocounts/pushManager/officialAccountMenuBarLast?appId='+appId,
    params,
  );
}

export async function officialAppLast(params) {
  return $x.post(
    '/officialAcocounts/pushManager/officialAccountAppId',
    params,
  );
}
